import React, { useState, useEffect } from 'react';
import { ErpBlockConfigurator, erpBlocksApi as webbuilderApi } from '..';
import { Code, CheckCircle, RefreshCw, Cpu } from 'lucide-react';

// ErpBlocksPage composes live dynamic ERP block slot configurations with live telemetry (R-MOD-2).
export function ErpBlocksPage(): React.JSX.Element {
  const [selectedSlot, setSelectedSlot] = useState<string>('coach.lms_courses');
  const [liveData, setLiveData] = useState<{ slot_key: string; items: unknown[] } | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      setLoading(true);
      try {
        const data = await webbuilderApi.getSlotData(selectedSlot);
        if (isMounted) {
          setLiveData(data);
        }
      } catch {
        if (isMounted) {
          setLiveData({ slot_key: selectedSlot, items: [] });
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [selectedSlot]);

  return (
    <div className="p-6 max-w-5xl mx-auto flex flex-col gap-6">
      <ErpBlockConfigurator selectedSlotKey={selectedSlot} onSelectSlot={setSelectedSlot} />

      {/* Live Backend Data Verification Panel */}
      <div className="p-6 bg-card border border-border rounded-xl flex flex-col gap-4">
        <div className="flex items-center justify-between border-b border-border pb-3">
          <div className="flex items-center gap-2">
            <Cpu className="h-4 w-4 text-primary" />
            <h3 className="text-sm font-semibold text-foreground">
              Live Backend API Query Response: <span className="font-mono text-xs text-primary">{selectedSlot}</span>
            </h3>
          </div>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            {loading ? (
              <span className="flex items-center gap-1 text-primary">
                <RefreshCw className="h-3.5 w-3.5 animate-spin" /> Fetching live slot...
              </span>
            ) : (
              <span className="flex items-center gap-1 text-emerald-600 dark:text-emerald-400">
                <CheckCircle className="h-3.5 w-3.5" /> Channel A Live In-Memory & DB Bridge Active
              </span>
            )}
          </div>
        </div>

        <div className="bg-muted/50 rounded-lg p-4 font-mono text-xs text-foreground overflow-x-auto border border-border max-h-60">
          <pre>{JSON.stringify(liveData, null, 2)}</pre>
        </div>
      </div>
    </div>
  );
}

export const handle = { crumb: 'Live ERP Data Blocks' };
